import React, { useMemo } from "react";
import { Box, Typography, alpha } from "@mui/material";
import CloudUpload from "@mui/icons-material/CloudUpload";
import { useTheme } from "@mui/material/styles";
import { useDropzone } from "react-dropzone";
import { useTenantTranslation } from "hooks/formatters";
import { useFileExplorerContext } from "./FileExplorerContext";
import { createDropHandler } from "./helpers";

export const FileDropZone: React.FC = () => {
  const { t } = useTenantTranslation();
  const theme = useTheme();
  const { onFileUpload, isLoading } = useFileExplorerContext();

  const handleDrop = useMemo(
    () => createDropHandler(onFileUpload),
    [onFileUpload]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    multiple: true,
    disabled: isLoading,
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: `2px dashed ${theme.palette.primary.main}`,
        borderRadius: 2,
        p: 4,
        m: 2,
        textAlign: "center",
        cursor: "pointer",
        backgroundColor: isDragActive
          ? alpha(theme.palette.primary.main, 0.1)
          : "transparent",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary.main, 0.05),
        },
      }}
    >
      <input {...getInputProps()} />
      <CloudUpload
        sx={{
          fontSize: 48,
          color: "primary.main",
          mb: 2,
        }}
      />
      <Typography variant="h6" gutterBottom>
        {isDragActive ? t("dropFilesHere") : t("uploadFileDescription")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {isDragActive ? "" : t("orClickToSelect")}
      </Typography>
    </Box>
  );
};
